// extracted by mini-css-extract-plugin
export default {"rating":"HH-z","numberOfStars":"IH-z","count":"JH-z","barGraphSpacing":"KH-z","barGraph":"LH-z"};